import React from 'react';
import { TableBody, TableRow, TableCell } from '@mui/material';
import TextInput from '../../../../components/UI/TextInput/TextInput';
import { IMailBox } from '../../../../models/site';
import { Delete } from '@mui/icons-material';

interface MailBoxesTableBodyProps {
  mailBoxes: IMailBox[] | undefined;
  draftValues: Record<string, string>;
  dirtyPositions: Set<number | string>;
  onChange: (position: number | string, value: string) => void;
  onRemove: (position: number | string) => void;
}

const MailBoxesTableBody: React.FC<MailBoxesTableBodyProps> = ({
  mailBoxes,
  draftValues,
  dirtyPositions,
  onChange,
  onRemove,
}) => {
  return (
    <TableBody>
      {mailBoxes
        ?.sort((a, b) => Number(a.position) - Number(b.position))
        .map((mb) => (
          <TableRow
            key={mb.position.toString()}
            className={
              'mailBoxesEditor__row' +
              (dirtyPositions.has(mb.position)
                ? ' mailBoxesEditor__row--dirty'
                : '')
            }
          >
            <TableCell>{mb.position}</TableCell>
            <TableCell>
              <TextInput
                id={`mailbox-${mb.position}`}
                value={draftValues[mb.position.toString()] ?? ''}
                onChange={(e: any) => onChange(mb.position, e.target.value)}
                error={draftValues[mb.position.toString()] === ''}
              />
            </TableCell>
            <TableCell>
              <Delete onClick={() => onRemove(mb.position)} />
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  );
};

export default MailBoxesTableBody;
